import { useFormikContext } from "formik";
import { isEmpty } from "lodash";

const ReportError = () => {
  const { errors } = useFormikContext();
  return (
    <div className="error py-2">{!isEmpty(errors) && "There are errors in the form. Please check your entries and correct them."}</div>
  )
}

export default ReportError;